export default __webpack_public_path__ + "static/media/ID_MIKE_Gromax Kawai.d5196e58.jpg";